wbApp.controller('ReservationConfirmDetailCtrl', ['$scope', '$translate', 'messageBoxSvc', 'studentSvc', 'pricingSvc',
    'reservationsSvc', 'securitySvc', 'onlinePaymentsSvc', 'accountingBookSvc','tenantSettingSvc',
function ($scope, $translate, messageBoxSvc, studentSvc, pricingSvc, reservationsSvc, securitySvc, onlinePaymentsSvc, accountingBookSvc,
          tenantSettingSvc) {

    $scope.price = null;
    $scope.isCalculating = false;
    $scope.tenantSettings = tenantSettingSvc.settings;

    $scope.domainName = $scope.domain[0].name +
        (!!$scope.domain[0].specializations.length
            ? ' - ' + $scope.domain[0].specializations[0].name
            : '');

    function updatePrice() {
        var selectedStudentsIds = _.map(_.filter($scope.students, { buy: true }), 'id');
        if (selectedStudentsIds.length > 0 &&
            !!$scope.selectedEmployee) {

            $scope.isCalculating = true;
            pricingSvc.calculateReservationPrice({
                userId: securitySvc.loggedInUser().userID,
                placeId: $scope.place.id,
                studentsIds: selectedStudentsIds,
                employeeId: $scope.selectedEmployee.id,
                reservationStartDate: $scope.startDate,
                reservationEndDate: $scope.endDate,
                domainId: $scope.domain[0].id,
                domainSpecializationId: !!$scope.domain[0].specializations.length
                    ? $scope.domain[0].specializations[0].id
                    : null
            }).$promise.then(
                function (data) {
                    $scope.price = data.price;
                    $scope.isCalculating = false;
                },
                function (error) {
                    $scope.price = null;
                    $scope.isCalculating = false;
                });
        } else {
            $scope.price = null;
        }
    }

    $scope.students = studentSvc.getCurrentAsync();

    $scope.selectedEmployee = _.head($scope.filteredEmployees);
    $scope.selectedEmployeeId = !!$scope.selectedEmployee
        ? $scope.selectedEmployee.id
        : 0;



    $scope.employeesSelectBoxOptions = {
        bindingOptions: {
            value: 'selectedEmployeeId'
        },
        valueExpr: "id",
        displayExpr: "fullName",
        items: $scope.filteredEmployees,
        onValueChanged: function (e) {
            $scope.selectedEmployee = _.find($scope.filteredEmployees, { id: e.value });
            updatePrice();
        }
    }

    $scope.onStudentSelectionChanged = function () {
        updatePrice();
    }

    $scope.isSaveDisabled = function () {
        return $scope.isCalculating ||
               $scope.isSaving ||
               (_.map(_.filter($scope.students, { buy: true }), 'id').length == 0);
    }

    $scope.onReservationConfimClick = function ($hide) {

        var model = {
            employeeId: $scope.selectedEmployeeId,
            placeId: $scope.place.id,
            price: $scope.price,
            registrationDate: moment().toDate(),
            reservationStartDate: $scope.startDate,
            reservationEndDate: $scope.endDate,
            userId: securitySvc.loggedInUser().userID,
            studentIds: (_.map(_.filter($scope.students, { buy: true }), 'id')),
            notes: $scope.note,
            domain: {
                id: $scope.domain[0].id,
                name: $scope.domain[0].name
            },
            domainSpecialization: !!$scope.domain[0].specializations.length
                ? {
                    id: $scope.domain[0].specializations[0].id,
                    name: $scope.domain[0].specializations[0].name
                }
                : null
        };

        $scope.isSaving = true;

        var insertResultPromise = reservationsSvc.insert(model);
        insertResultPromise.$promise.then(
            function (data) {
                $scope.isSaving = false;
                $hide();

                accountingBookSvc.getDefaultAsync().then(function (acc) {
                    if (!!acc && !!acc.onlinePaymentConfigurationID) {
                        let invoiceId = data.invoiceId;
                        let price = data.price;
                        if (price > 0) {
                            messageBoxSvc.showMessageDlg({
                                title: 'TXT_TITLE_CONFIRM_ONLINE_PAYMENT',
                                message: '<i class="fa fa-3x fa-credit-card text-success pull-right" aria-hidden="true"></i>' +
                                    $translate.instant('TXT_CONFIRM_CONFIRM_START_ONLINE_PAYMENT'),
                                buttons: [{
                                    text: 'TXT_BTN_NO'
                                }, {
                                    text: 'TXT_BTN_YES',
                                    callback: function () {
                                        return onlinePaymentsSvc.startOnlinePayment([invoiceId], price).$promise;
                                    }
                                }]
                            });
                        }
                    }
                });
                
                $scope.onSave(data);
            },
            function (error) {
                $scope.isSaving = false;
                messageBoxSvc.showMessageDlg({
                    title: 'TXT_ALERT_TITLE_ENTITY_SAVE_ERROR',
                    message: error.message,
                    buttons: [{
                        text: 'TXT_BTN_OK'
                    }]
                });
            });
    }
}]);
